// Theme colors from original PEA project
export const theme = {
  colors: {
    primary: '#D041E6',
    primaryStrong: '#B02BC4',
    primaryDark: '#8D2F88',
    accent: '#F8C444',
    accentLight: '#FFD560',
    surface: '#FFFFFF',
    background: '#EFEEF4',
    backgroundLight: '#F4E8F6',
    text: '#414141',
    textMuted: '#878787',
    border: '#dcdcdc',
    success: '#06799f',
    error: '#ff0000',
  },
  fonts: {
    primary: "'Kanit', sans-serif",
    secondary: "'Sarabun', sans-serif",
    tertiary: "'Bai Jamjuree', sans-serif",
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.12)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 20px rgba(0,0,0,0.15)',
    xl: '0 20px 40px rgba(0,0,0,0.2)',
  },
  zIndex: {
    dropdown: 1000,
    modal: 2000,
    tooltip: 3000,
    notification: 4000,
  },
};

export const backgroundGradients = [
  { name: 'PEA Purple', value: 'linear-gradient(135deg, #8D2F88 0%, #6919A2 100%)' },
  { name: 'PEA Light', value: 'linear-gradient(135deg, #F4E8F6 0%, #EFEEF4 100%)' },
  { name: 'Ocean Blue', value: 'linear-gradient(135deg, #00c6fb 0%, #005bea 100%)' },
  { name: 'Warm Sunset', value: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)' },
  { name: 'Nature Green', value: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)' },
  { name: 'Midnight', value: 'linear-gradient(135deg, #232526 0%, #414345 100%)' },
  { name: 'Royal Gold', value: 'linear-gradient(135deg, #BF953F 0%, #FCF6BA 50%, #B38728 100%)' },
  { name: 'Clean Gray', value: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' },
  { name: 'Neon Life', value: 'linear-gradient(135deg, #B621FE 0%, #1FD1F9 100%)' },
  { name: 'Cherry', value: 'linear-gradient(135deg, #eb3349 0%, #f45c43 100%)' },
];

// Gallery interaction settings
export const gallerySettings = {
  dragSensitivity: 1.0, // 1.0 = normal, >1 = faster, <1 = slower
  resizeSensitivity: 1.0,
  minItemSize: 50, // Minimum width/height in pixels
  collisionShrinkAmount: 0.9, // How much to shrink on collision (0.9 = 90% of original)
  bounds: {
    maxWidth: 754, // Section width minus padding
    maxHeight: 510, // Section height minus padding
  },
};

// Canvas size presets (in pixels at 96 DPI)
// A4 at 96 DPI: 210mm = 794px, 297mm = 1123px
export const canvasSizes = {
  'A4 Portrait': { 
    width: 794, 
    height: 1123, 
    label: 'A4 แนวตั้ง (210×297mm)', 
    mm: { width: 210, height: 297 } 
  },
  'A4 Landscape': { 
    width: 1123, 
    height: 794, 
    label: 'A4 แนวนอน (297×210mm)',
    mm: { width: 297, height: 210 }
  },
};

// Grid settings
export const gridConfig = {
  defaultSize: 20, // grid cell size in pixels
  minSize: 10,
  maxSize: 100,
  snapThreshold: 5, // snap when within this many pixels
};

// Font options (Thai fonts from original project)
export const fontOptions = [
  { value: 'Kanit', label: 'Kanit' },
  { value: 'Sarabun', label: 'Sarabun' },
  { value: 'Bai Jamjuree', label: 'Bai Jamjuree' },
  { value: 'Chakra Petch', label: 'Chakra Petch' },
  { value: 'Charm', label: 'Charm' },
  { value: 'Charmonman', label: 'Charmonman' },
  { value: 'Fahkwang', label: 'Fahkwang' },
  { value: 'K2D', label: 'K2D' },
  { value: 'KoHo', label: 'KoHo' },
  { value: 'Kodchasan', label: 'Kodchasan' },
  { value: 'Krub', label: 'Krub' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Niramit', label: 'Niramit' },
  { value: 'Prompt', label: 'Prompt' },
  { value: 'Srisakdi', label: 'Srisakdi' },
];

// Text alignment options
export const textAlignOptions = [
  { value: 'left', label: 'ชิดซ้าย', icon: 'FaAlignLeft' },
  { value: 'center', label: 'กึ่งกลาง', icon: 'FaAlignCenter' },
  { value: 'right', label: 'ชิดขวา', icon: 'FaAlignRight' },
  { value: 'justify', label: 'เต็มแนว', icon: 'FaAlignJustify' },
]

// Frame styles for gallery items
export const frameStyles = [
  { 
    id: 'none', 
    name: 'ไม่มีกรอบ', 
    style: { border: 'none', borderRadius: '0', boxShadow: 'none', padding: '0' } 
  },
  { 
    id: 'simple', 
    name: 'เส้นขอบบาง', 
    style: { border: '2px solid #000', borderRadius: '0', boxShadow: 'none', padding: '0' } 
  },
  { 
    id: 'rounded', 
    name: 'มุมมน', 
    style: { border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', padding: '0' } 
  },
  { 
    id: 'shadow', 
    name: 'เงาลอย', 
    style: { border: 'none', borderRadius: '4px', boxShadow: '0 10px 20px rgba(0,0,0,0.15)', padding: '0' } 
  },
  { 
    id: 'polaroid', 
    name: 'โพลารอยด์', 
    style: { border: '1px solid #ddd', borderRadius: '2px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', padding: '10px 10px 40px 10px', background: '#fff' } 
  },
  { 
    id: 'neon', 
    name: 'นีออน', 
    style: { border: '2px solid #D041E6', borderRadius: '8px', boxShadow: '0 0 10px #D041E6', padding: '0' } 
  },
  { 
    id: 'gold', 
    name: 'กรอบทอง', 
    style: { border: '4px solid #FFD700', borderRadius: '4px', boxShadow: 'inset 0 0 10px rgba(0,0,0,0.2)', padding: '0' } 
  },
  { 
    id: 'double', 
    name: 'เส้นคู่', 
    style: { border: '4px double #333', borderRadius: '0', boxShadow: 'none', padding: '4px' } 
  },
  { 
    id: 'circle', 
    name: 'วงกลม', 
    style: { border: 'none', borderRadius: '50%', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', padding: '0' } 
  },
  { 
    id: 'gradient', 
    name: 'ไล่สี', 
    style: { border: '4px solid transparent', borderRadius: '8px', backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #D041E6, #F8C444)', backgroundOrigin: 'border-box', backgroundClip: 'content-box, border-box', padding: '0' } 
  },
];

// Section types (containers for blocks)
export const sectionTypes = {
  HEADER: 'header',
  GALLERY: 'gallery',
  DETAIL: 'detail',
  FOOTER: 'footer',
};

// Block types (elements inside sections)
export const blockTypes = {
  LOGO: 'logo',
  TEXT: 'text',
  FRAME: 'frame',
  DETAIL: 'detail',
  IMAGE: 'image',
  QRCODE: 'qrcode',
};

// Default block styles
export const defaultBlockStyles = {
  [blockTypes.LOGO]: {
    objectFit: 'contain',
    borderRadius: 0,
  },
  [blockTypes.QRCODE]: {
    value: 'https://www.pea.co.th',
    color: '#000000',
    backgroundColor: '#FFFFFF',
    level: 'M', // L, M, Q, H
    includeMargin: false,
  },
  [blockTypes.TEXT]: {
    fontFamily: 'Kanit',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none',
    textAlign: 'left',
    color: '#414141',
    backgroundColor: 'transparent',
    backgroundType: 'solid',
    backgroundGradient: 'linear-gradient(90deg, #8D2F88 0%, #9235B5 100%)',
    padding: 8,
  },
  [blockTypes.FRAME]: {
    backgroundColor: 'transparent',
    backgroundType: 'solid',
    backgroundGradient: 'linear-gradient(90deg, #8D2F88 0%, #9235B5 100%)',
    borderRadius: 8,
    borderWidth: 2,
    borderColor: '#8D2F88',
  },
  [blockTypes.DETAIL]: {
    fontFamily: 'Sarabun',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'none',
    textAlign: 'left',
    color: '#878787',
    backgroundColor: 'transparent',
    backgroundType: 'solid',
    padding: 8,
  },
  [blockTypes.IMAGE]: {
    objectFit: 'cover',
    borderRadius: 0,
  },
};

// Header layout options
export const headerLayoutOptions = [
  { value: 'text-logo', label: 'Text + Logo', icon: 'TL' },
  { value: 'logo-text', label: 'Logo + Text', icon: 'LT' },
  { value: 'text-only', label: 'Text Only', icon: 'T' },
  { value: 'logo-only', label: 'Logo Only', icon: 'L' },
];

// Default section styles
export const defaultSectionStyles = {
  [sectionTypes.HEADER]: {
    backgroundColor: '#FFFFFF',
    borderColor: '#8D2F88',
    borderWidth: 0,
    borderStyle: 'solid',
    layout: 'logo-text', // default header layout
  },
  [sectionTypes.GALLERY]: {
    backgroundColor: '#FFFFFF',
    borderColor: '#A0499B',
    borderWidth: 0,
    borderStyle: 'solid',
  },
  [sectionTypes.DETAIL]: {
    backgroundColor: '#FFFFFF',
    borderColor: '#9235B5',
    borderWidth: 0,
    borderStyle: 'solid',
  },
  [sectionTypes.FOOTER]: {
    backgroundColor: '#8D2F88', // Default PEA Purple for footer
    borderColor: '#8D2F88',
    borderWidth: 0,
    borderStyle: 'solid',
    footerText: '1129 PEA Contact Center',
    footerTextAlign: 'center',
    footerTextColor: '#FFFFFF',
    footerFontSize: 18,
  },
};

// Image fit options
export const imageFitOptions = [
  { value: 'cover', label: 'Cover (ครอบคลุม)' },
  { value: 'contain', label: 'Contain (พอดี)' },
  { value: 'fill', label: 'Fill (ยืดเต็ม)' },
  { value: 'none', label: 'None (ไม่ปรับ)' },
];

// Animation config for drag
export const dragAnimationConfig = {
  transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
  collisionPushDistance: 20, // pixels to push away when collision detected
};

// Gallery Layout Templates
// Gallery content width = 794px (canvas) - 40px (padding 20px left+right) = 754px
// Gap between items: 5px (reduced from 10px)
export const galleryLayouts = [
  {
    id: 'grid-2x2',
    name: 'Grid 2×2',
    icon: '⊞',
    slots: [
      // Gallery section height ≈ 618px, header ≈ 68px, grid area ≈ 550px
      // With padding 20px all sides: available = 754×510px
      // 2 columns: (754-15)/2 = 369.5px each, 2 rows: (510-15)/2 = 247.5px each
      // Gap: 15px between images
      // Using 4:3 ratio landscape: width=369, height=277 BUT limit to available height
      { id: 1, x: 0, y: 0, width: 369, height: 247 },
      { id: 2, x: 384, y: 0, width: 370, height: 247 },
      { id: 3, x: 0, y: 262, width: 369, height: 248 },
      { id: 4, x: 384, y: 262, width: 370, height: 248 },
    ],
  },
  {
    id: 'grid-3x3',
    name: 'Grid 3×3',
    icon: '⊞⊞',
    slots: [
      // Available: 754×510px, 3 cols, 3 rows, gap 15px
      // Width per col: (754-30)/3 = 241.33px
      // Height per row: (510-30)/3 = 160px
      { id: 1, x: 0, y: 0, width: 241, height: 160 },
      { id: 2, x: 256, y: 0, width: 241, height: 160 },
      { id: 3, x: 512, y: 0, width: 242, height: 160 },
      { id: 4, x: 0, y: 175, width: 241, height: 160 },
      { id: 5, x: 256, y: 175, width: 241, height: 160 },
      { id: 6, x: 512, y: 175, width: 242, height: 160 },
      { id: 7, x: 0, y: 350, width: 241, height: 160 },
      { id: 8, x: 256, y: 350, width: 241, height: 160 },
      { id: 9, x: 512, y: 350, width: 242, height: 160 },
    ],
  },
  {
    id: 'hero-4',
    name: 'Hero + 4',
    icon: '◰',
    slots: [
      { id: 1, x: 0, y: 0, width: 490, height: 325 },
      { id: 2, x: 505, y: 0, width: 249, height: 155 },
      { id: 3, x: 505, y: 170, width: 249, height: 155 },
      { id: 4, x: 0, y: 340, width: 369, height: 170 },
      { id: 5, x: 384, y: 340, width: 370, height: 170 },
    ],
  },
  {
    id: 'masonry-left',
    name: 'Masonry L',
    icon: '⊟',
    slots: [
      { id: 1, x: 0, y: 0, width: 241, height: 245 },
      { id: 2, x: 0, y: 260, width: 241, height: 250 },
      { id: 3, x: 256, y: 0, width: 241, height: 155 },
      { id: 4, x: 256, y: 170, width: 241, height: 155 },
      { id: 5, x: 256, y: 340, width: 241, height: 170 },
      { id: 6, x: 512, y: 0, width: 242, height: 245 },
      { id: 7, x: 512, y: 260, width: 242, height: 250 },
    ],
  },
  {
    id: 'horizontal-3',
    name: 'แนวนอน 3',
    icon: '⊟⊟⊟',
    slots: [
      { id: 1, x: 0, y: 0, width: 241, height: 510 },
      { id: 2, x: 256, y: 0, width: 241, height: 510 },
      { id: 3, x: 512, y: 0, width: 242, height: 510 },
    ],
  },
  {
    id: 'vertical-3',
    name: 'แนวตั้ง 3',
    icon: '⊏',
    slots: [
      { id: 1, x: 0, y: 0, width: 754, height: 160 },
      { id: 2, x: 0, y: 175, width: 754, height: 160 },
      { id: 3, x: 0, y: 350, width: 754, height: 160 },
    ],
  },
  {
    id: 'l-shape',
    name: 'L-Shape',
    icon: '◧',
    slots: [
      { id: 1, x: 0, y: 0, width: 490, height: 325 },
      { id: 2, x: 505, y: 0, width: 249, height: 155 },
      { id: 3, x: 505, y: 170, width: 249, height: 155 },
      { id: 4, x: 0, y: 340, width: 241, height: 170 },
      { id: 5, x: 256, y: 340, width: 241, height: 170 },
      { id: 6, x: 512, y: 340, width: 242, height: 170 },
    ],
  },
  {
    id: 'collage-mix',
    name: 'Collage Mix',
    icon: '⧉',
    slots: [
      { id: 1, x: 0, y: 0, width: 241, height: 160 },
      { id: 2, x: 256, y: 0, width: 241, height: 160 },
      { id: 3, x: 0, y: 175, width: 369, height: 335 },
      { id: 4, x: 512, y: 0, width: 242, height: 160 },
      { id: 5, x: 384, y: 175, width: 170, height: 335 },
      { id: 6, x: 569, y: 175, width: 185, height: 335 },
    ],
  },
  {
    id: 'single-large',
    name: 'ภาพเดียว',
    icon: '◭',
    slots: [
      { id: 1, x: 0, y: 0, width: 754, height: 510 },
    ],
  },
  {
    id: 'zigzag',
    name: 'Zigzag',
    icon: '⌇',
    slots: [
      { id: 1, x: 0, y: 0, width: 369, height: 155 },
      { id: 2, x: 384, y: 0, width: 370, height: 155 },
      { id: 3, x: 192, y: 170, width: 370, height: 155 },
      { id: 4, x: 0, y: 340, width: 369, height: 170 },
      { id: 5, x: 384, y: 340, width: 370, height: 170 },
    ],
  },
  {
    id: 'pyramid',
    name: 'Pyramid',
    icon: '△',
    slots: [
      { id: 1, x: 272, y: 0, width: 210, height: 155 },
      { id: 2, x: 134, y: 170, width: 210, height: 155 },
      { id: 3, x: 359, y: 170, width: 210, height: 155 },
      { id: 4, x: 0, y: 340, width: 177, height: 170 },
      { id: 5, x: 192, y: 340, width: 177, height: 170 },
      { id: 6, x: 384, y: 340, width: 177, height: 170 },
      { id: 7, x: 576, y: 340, width: 178, height: 170 },
    ],
  },
  {
    id: 'magazine',
    name: 'Magazine',
    icon: '⊞',
    slots: [
      { id: 1, x: 0, y: 0, width: 241, height: 325 },
      { id: 2, x: 256, y: 0, width: 241, height: 155 },
      { id: 3, x: 512, y: 0, width: 242, height: 155 },
      { id: 4, x: 256, y: 170, width: 498, height: 155 },
      { id: 5, x: 0, y: 340, width: 369, height: 170 },
      { id: 6, x: 384, y: 340, width: 370, height: 170 },
    ],
  },
  {
    id: 'mosaic',
    name: 'Mosaic',
    icon: '⊟',
    slots: [
      { id: 1, x: 0, y: 0, width: 165, height: 160 },
      { id: 2, x: 180, y: 0, width: 280, height: 160 },
      { id: 3, x: 475, y: 0, width: 279, height: 160 },
      { id: 4, x: 0, y: 175, width: 225, height: 160 },
      { id: 5, x: 240, y: 175, width: 190, height: 160 },
      { id: 6, x: 445, y: 175, width: 309, height: 160 },
      { id: 7, x: 0, y: 350, width: 241, height: 160 },
      { id: 8, x: 256, y: 350, width: 241, height: 160 },
      { id: 9, x: 512, y: 350, width: 242, height: 160 },
    ],
  },
  {
    id: 'spotlight',
    name: 'Spotlight',
    icon: '◉',
    slots: [
      { id: 1, x: 192, y: 30, width: 370, height: 295 },
      { id: 2, x: 0, y: 0, width: 177, height: 155 },
      { id: 3, x: 0, y: 170, width: 177, height: 155 },
      { id: 4, x: 577, y: 0, width: 177, height: 155 },
      { id: 5, x: 577, y: 170, width: 177, height: 155 },
      { id: 6, x: 0, y: 340, width: 241, height: 170 },
      { id: 7, x: 256, y: 340, width: 241, height: 170 },
      { id: 8, x: 512, y: 340, width: 242, height: 170 },
    ],
  },
  {
    id: 'timeline',
    name: 'Timeline',
    icon: '⋯',
    slots: [
      { id: 1, x: 0, y: 0, width: 177, height: 510 },
      { id: 2, x: 192, y: 0, width: 177, height: 247 },
      { id: 3, x: 192, y: 262, width: 177, height: 248 },
      { id: 4, x: 384, y: 0, width: 177, height: 247 },
      { id: 5, x: 384, y: 262, width: 177, height: 248 },
      { id: 6, x: 576, y: 0, width: 178, height: 510 },
    ],
  },
];

// Section proportions (% of canvas height) - must sum to 1.0 (100%)
export const sectionProportions = {
  [sectionTypes.HEADER]: 0.15,    // 15% = ~168px
  [sectionTypes.GALLERY]: 0.55,   // 55% = ~618px
  [sectionTypes.DETAIL]: 0.25,    // 25% = ~281px
  [sectionTypes.FOOTER]: 0.05,    // 5%  = remaining (to ensure exact 1123px)
  // Total: 100% = 1123px (A4 Portrait height)
};

// Section Y positions (manual override for precise positioning)
// Set to null to use auto-calculated positions
export const sectionYPositions = {
  [sectionTypes.HEADER]: 0,      // y = 0px
  [sectionTypes.GALLERY]: 140,  // y = 168px (after header)
  [sectionTypes.DETAIL]: 600,    // y = 786px (after gallery)
  [sectionTypes.FOOTER]: 820,   // y = 1067px (after detail)
};

// Section heights (manual override)
// Set to null to use proportional heights
export const sectionHeights = {
  [sectionTypes.HEADER]: 168,    // height = 168px
  [sectionTypes.GALLERY]: 600,   // height = 618px
  [sectionTypes.DETAIL]: 281,    // height = 281px
  [sectionTypes.FOOTER]: 56,     // height = 56px
};

// Gallery grid settings
export const galleryGridConfig = {
  enabled: true,     // Show/hide grid overlay
  size: 20,          // Grid cell size in pixels
  gap: 0,            // Minimum gap between items (pixels) - ชิดสนิท
  color: 'rgba(141, 47, 136, 0.1)', // Grid line color
};
